import styled from 'styled-components'

export const DashboardHeaderContainer = styled.div.attrs({
})`           
    height: 80px;
    width: ${props => props.headerSecondary ? '100%' : 'calc(100% - 264px)'};

    background: ${props => props.headerSecondary ? props.theme.palette.colors.background : props.theme.palette.primary.main};
    padding: 0 25px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 1px 4px ${props => props.theme.palette.colors.shadow};
    ${p => p.headerSecondary ? `
        border-bottom: 1px solid ${p.theme.palette.colors.white};
        `: ``};
    transition: width 0.3s;

    @media (max-width: 991px) {
        width: 100%;
    }
`;

export const DashboardHeaderAction = styled.div.attrs({
})`           
    color: ${props => props.theme.palette.colors.white};
    font-size: 15px;
    text-transform: uppercase;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    display: none;
    
    @media (max-width: 991px) {
        display: block;
    }
`;
export const DashboardHeaderBack = styled.div.attrs({
})`           
    color: ${props => props.theme.palette.colors.white};
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`;

export const AppLogo = styled.img.attrs({
    src: `/logo1024.png`,
    alt: "logo-icon",
    height: 50
})`            
`;

export const DashboardHeaderActionIcon = styled.img.attrs({
})`           
    margin-right: 10px;
`;

export const DashboardMenuContainer = styled.div.attrs({
})`           
    position: fixed;
    top:0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 100;
    background: ${props => props.theme.palette.colors.shadow};
`;

export const DashboardMenu = styled.div.attrs({
    className: 'menu-contant'
})`           
    max-width: 389px;
    background: ${props => props.theme.palette.colors.white};
    width: 100%;
    min-height: 100vh;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: auto;
`;

export const DashboardMenuHeader = styled.div.attrs({
})`           
    height: 60px;
    width: 100%; 
    display: flex;
    align-items: center;
    padding: 0 20px;

    text-transform: uppercase;
    font-size: 15px;
    color: ${props => props.theme.palette.colors.white};
    cursor: pointer;

    background: ${props => props.theme.palette.primary.main};
`;

export const DashboardMenuHeaderIcon = styled.img.attrs({
})`           
    margin-right: 20px;
    cursor: pointer;
`;

export const DashboardMenuHeaderUserContent = styled.div.attrs({
})`           
    padding: 27px 25px;
    border-bottom: 1px solid ${props => props.theme.palette.colors.lightgrey};
    margin-bottom: 28px;
`;

export const DashboardMenuHeaderUserImage = styled.div.attrs({
})`           
    width: 160px;
    height: 160px; 
    background: ${props => props.theme.palette.colors.grey} url(/logo1024.png) no-repeat center center / cover;
    margin: 0 auto 12px;
    overflow: hidden;
`;

export const DashboardMenuHeaderUserText = styled.div.attrs({
})`           
    font-size: 15px;
    font-weight: bold;
    color: ${props => props.theme.palette.colors.grey};
    margin-bottom: 12px; 
`;

export const DashboardMenuOption = styled.div.attrs({
})`           
    padding: 20px 30px;
    font-size: 15px;
    color: ${props => props.theme.palette.colors.grey};
    cursor: pointer; 

    &:hover{
        text-decoration: underline;
    }
    
    ${props => props.active ? `
            background: ${props.theme.palette.primary.main};
            font-size: 15px;
            font-weight: bold;
            color: ${props.theme.palette.colors.white};
        ` : ``
    }
`;

export const DashboardMenuContent = styled.div.attrs({
})` 
    flex:1;
`;

export const DashboardMenuFooter = styled.div.attrs({
})`
    padding: 20px;
`;

export const DashboardVersionContent = styled.div.attrs({
})` 
    margin: 24px 0;
`;

export const DashboardVersionText = styled.div.attrs({
})`
    font-size: 15px;
    font-weight: bold;
    color: ${props => props.theme.palette.colors.grey};
    text-align: center; 
`;


export const InputSearchContainer = styled.div.attrs({
})`
    width: 328px;
    @media(max-width: 450px) {
        display: none;
    };
`;
export const InfoContainer = styled.div.attrs({
})`
    display: flex;
    gap: 24px;
    margin-left: 12px;
    @media (max-width: 1000px) {
        gap: 12px;

    }
`;

export const InfoItem = styled.div.attrs({
})`
    display: flex;
    height: 40px;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    border: 1px solid ${props => props.theme.palette.colors.shadow};
    cursor: pointer;
    transition: all 0.3s;
    &:hover{
    transform: scale(1.05);
    };

    @media(max-width: 771px) {
        display: none;
    };
`;

export const InfoUser = styled.div.attrs({
})`
    display: flex;
    height: 40px;
    padding: 8px;
    align-items: center;
    gap: 8px;
    background: ${props => props.headerSecondary ? props.theme.palette.colors.white : props.theme.palette.colors.light};   
    border-radius: 8px;
    position: relative;
    cursor: pointer;
    min-width: fit-content;
`;

export const InfoUserContent = styled.div.attrs({
})`
    display: flex;
    align-items: center;
    gap: 8px;
`;
export const UserInitial = styled.div.attrs({
})`
    width: 24px;
    height: 24px;
    border-radius: 4px;
    background: ${props => props.theme.palette.green.main};   
    font-family: Gilroy;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    color: ${p => p.theme.palette.colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const InfoUserContainer = styled.div.attrs({
})`
    background: ${props => props.theme.palette.colors.bluestrong};   
    border-radius: 8px;
    position: absolute;
    z-index: 101;
    top: 45px;
    right: 0px;
    overflow: hidden;
`;
export const UserOptions = styled.div.attrs({
})`
    display: flex;
    padding: 12px 20px;
    width: 182px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;

    cursor: pointer;
    transition: all 0.3s;
    color: ${props => props.theme.palette.colors.white};
    &:hover{
        background: ${props => props.theme.palette.primary.main};
        color: ${props => props.theme.palette.colors.white};
    }
`;




export const UserName = styled.div.attrs({
})`
    font-family: Gilroy;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    color: ${props => props.headerSecondary ? props.theme.palette.colors.black : props.theme.palette.colors.white};
    white-space: nowrap;
    text-transform: uppercase;
`;

export const BackText = styled.div.attrs({
})`
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    color: ${props => props.theme.palette.colors.black};
`;

export const InfoText = styled.div.attrs({
})`
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    color: ${props => props.theme.palette.colors.grey};
`;

export const IconContent = styled.div.attrs({
})`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const HomeHeaderContainer = styled.header`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 110;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 8px 48px;
    background: linear-gradient(
        180deg,
        ${({ theme }) => theme.palette.colors.backgroundStrong} 0%,
        ${({ theme }) => theme.palette.colors.backgroundSoft} 58%,
        ${({ theme }) => theme.palette.colors.backgroundTransparent} 100%
    );
    box-shadow: 0 1px 3px ${({ theme }) => theme.palette.colors.shadowStrong};

    @media (max-width: 991px) {
        padding: 18px 18px 12px;
        gap: 12px;
    }

    @media (max-width: 480px) {
        padding: 14px 12px 10px;
        gap: 8px;
    }
`;

export const HomeHeaderDismissLayer = styled.div`
    position: fixed;
    inset: 0;
    z-index: 109;
    background: transparent;
`;

export const HomeHeaderSide = styled.div`
    display: flex;
    align-items: center;
    gap: 18px;
    min-width: 0;

    @media (max-width: 480px) {
        gap: 10px;

        > img {
            width: min(42vw, 180px);
        }
    }
`;

export const HomeHeaderButton = styled.button.attrs({
    type: "button",
})`
    border: 0;
    background: transparent;
    padding: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 12px;
    transition: background 0.2s ease;

    &:hover {
        background: ${({ theme }) => theme.palette.colors.buttonGhost};
    }
`;

export const HomeMenuGlyph = styled.span`
    width: 18px;
    height: 14px;
    position: relative;
    display: inline-block;

    &::before,
    &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        height: 2px;
        border-radius: 999px;
        background: ${({ theme }) => theme.palette.colors.text};
    }

    &::before {
        top: 0;
        box-shadow: 0 6px 0 ${({ theme }) => theme.palette.colors.text};
    }

    &::after {
        bottom: 0;
        width: 11px;
    }
`;

export const HomeBrand = styled.div`
    display: flex;
    align-items: baseline;
    gap: 8px;
    min-width: 0;
`;

export const HomeBrandWordmark = styled.div`
    font-family: Inter, sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.04em;
    color: ${({ theme }) => theme.palette.colors.text};
    white-space: nowrap;

    span {
        color: ${({ theme }) => theme.palette.blue.main};
    }

    @media (max-width: 991px) {
        font-size: 22px;
    }
`;

export const HomeBrandCaption = styled.div`
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.2;
    color: ${({ theme }) => theme.palette.colors.subdued};
    white-space: nowrap;

    @media (max-width: 991px) {
        display: none;
    }
`;

export const HomeHeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: 480px) {
        gap: 8px;
    }
`;

export const HomeHeaderSearch = styled.div`
    flex: 1;
    min-width: 220px;
    max-width: 440px;

    @media (max-width: 991px) {
        display: none;
    }
`;

export const HomeDesktopActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: 991px) {
        display: none;
    }
`;

export const HomeActionButton = styled.button.attrs({
    type: "button",
})`
    min-width: ${({ iconOnly }) => iconOnly ? '40px' : '0'};
    min-height: 40px;
    border-radius: 999px;
    border: 1px solid transparent;
    background: transparent;
    color: ${({ theme }) => theme.palette.colors.muted};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: ${({ iconOnly }) => iconOnly ? '8px' : '8px 14px'};
    cursor: pointer;
    white-space: nowrap;
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 500;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
    position: relative;

    &:hover {
        background: ${({ theme }) => theme.palette.colors.buttonGhost};
    }

    @media (max-width: 720px) {
        padding: ${({ iconOnly }) => iconOnly ? '8px' : '8px 12px'};
    }
`;

export const HomeNotificationBadge = styled.span`
    position: absolute;
    top: 1px;
    right: 0;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border: 2px solid ${({ theme }) => theme.palette.colors.backgroundStrong};
    border-radius: 999px;
    background: ${({ theme }) => theme.palette.colors.red};
    color: ${({ theme }) => theme.palette.blue.contrastText};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: Inter, sans-serif;
    font-size: 9px;
    font-weight: 700;
    line-height: 1;
    box-sizing: border-box;
`;

export const HomeActionText = styled.span`
    max-width: 148px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.palette.colors.muted};
    
    @media (max-width: 720px) {
        max-width: 82px;
    }
`;

export const HomeUserIdentity = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
`;

export const HomeUserAvatar = styled.span`
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 50%;
    overflow: hidden;
    background:
        ${({ image, theme }) => image
        ? `url(${image}) no-repeat center center / cover`
        : `radial-gradient(circle at 30% 28%, ${theme.palette.colors.surfaceElevated} 0%, ${theme.palette.colors.backgroundStrong} 72%)`};
    border: 2px solid ${({ theme }) => theme.palette.blue.main};
    box-shadow: 0 10px 24px ${({ theme }) => theme.palette.colors.shadowStrong};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0
`;

export const HomeUserAvatarInitials = styled.span`
    font-family: Gilroy;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.palette.colors.text};
    text-transform: uppercase;
`;

export const HomeGlobeGlyph = styled.span`
    width: 16px;
    height: 16px;
    border-radius: 999px;
    border: 1.6px solid ${({ theme }) => theme.palette.colors.muted};
    position: relative;

    &::before,
    &::after {
        content: '';
        position: absolute;
        background: ${({ theme }) => theme.palette.colors.muted};
    }

    &::before {
        inset: 7px 2px;
        height: 1px;
    }

    &::after {
        inset: 2px 7px;
        width: 1px;
    }
`;

export const HomeDropdownWrap = styled.div`
    position: relative;
`;

export const HomeDropdown = styled.div`
    position: absolute;
    top: calc(100%);
    right: 0;
    min-width: 190px;
    border-radius: 18px;
    border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    background: ${({ theme }) => theme.palette.colors.backgroundStrong};
    box-shadow: 0 24px 60px ${({ theme }) => theme.palette.colors.shadowStrong};
    padding: 8px;
    z-index: 130;
`;

export const HomeDropdownItem = styled.button.attrs({
    type: "button",
})`
    width: 100%;
    border: 0;
    border-radius: 12px;
    background: transparent;
    color: ${({ theme }) => theme.palette.colors.muted};
    padding: 11px 12px;
    text-align: left;
    cursor: pointer;
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 500;

    &:hover {
        background: ${({ theme }) => theme.palette.colors.surfaceSoft};
        color: ${({ theme }) => theme.palette.colors.text};
    }
`;
